import { createSelector } from 'reselect'

const getHostname = state => {
  return window.location.hostname
}


export const getBrand = createSelector([getHostname], (hostname) => {
  if (hostname.includes('smartice')) {
    return 'SmartIce'
  } else if (hostname.includes('polarview')) {
    return 'PolarView'
  } else if (hostname.includes('arctic')) {
    return 'ArcticCrowdSource'
  } else if (hostname.includes('icedrift')) {
    return 'IceDrift'
  } else if (hostname.includes('churchill')) {
    return 'Churchill'
  } else if (hostname.includes('energir')) {
    return 'Energir'
  } else if (hostname.includes('alpha')) {
    return 'alpha'
  } else {
    // return 'Churchill'
    // return 'PolarView'
    // return 'IceDrift'
    return 'LookNorth'
  }
})



// WEBPACK FOOTER //
// ./src/selectors/brandSelector.js